import React, { useState } from 'react';
import { C, fmt } from '../tokens.js';
import { Card, Btn, BkHdr, Badge, Divider } from '../components/ui.jsx';
import { D } from '../mock-data.js';

export const BookingServiceScreen = ({service:svc,branch:b,navigate,goBack}) => (
  <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column'}}>
    <BkHdr title="Service details" onBack={goBack}/>
    <div style={{flex:1,overflowY:'auto',padding:'20px',display:'flex',flexDirection:'column',gap:16}}>
      <div style={{height:140,borderRadius:20,background:'linear-gradient(135deg,#fce7f3,#d4f1f7)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:72}}>✂️</div>
      <div>
        <h2 style={{fontSize:22,fontWeight:800,color:C.text,marginBottom:4}}>{svc.name}</h2>
        <p style={{fontSize:13,color:C.textMed}}>{b.name} · ⏱ {svc.duration} min</p>
      </div>
      <Card style={{padding:'14px 16px'}}>
        {[['Price',fmt(svc.priceP)],['Advance required',svc.advanceP>0?fmt(svc.advanceP):'None (pay at salon)']].map(([l,v],i)=>(
          <div key={i} style={{display:'flex',justifyContent:'space-between',marginBottom:i===0?10:0}}><span style={{fontSize:14,color:C.textMed}}>{l}</span><span style={{fontSize:15,fontWeight:800,color:C.primary}}>{v}</span></div>
        ))}
      </Card>
      {svc.refundBy&&<div style={{padding:'14px 16px',background:C.warningBg,borderRadius:14,border:'1px solid #fde68a'}}>
        <p style={{fontSize:13,fontWeight:700,color:'#92400e',marginBottom:4}}>⚠️ Cancellation policy</p>
        <p style={{fontSize:13,color:'#a16207'}}>Free until <b>{svc.refundBy}</b> before slot. Advance of <b>{fmt(svc.advanceP)}</b> is non-refundable after.</p>
      </div>}
    </div>
    <div style={{padding:'12px 20px 20px',background:C.white,borderTop:`1px solid ${C.border}`}}>
      <Btn full onClick={()=>navigate('booking-flow',{service:svc,branch:b})}>Select date & slot →</Btn>
    </div>
  </div>
);

export const BookingFlowScreen = ({service:svc,branch:b,navigate,goBack}) => {
  const [step,setStep]=useState(0);
  const [selDay,setSelDay]=useState(1);
  const [selSlot,setSelSlot]=useState(null);
  const [notes,setNotes]=useState('');
  const [addOns,setAddOns]=useState([]);
  const [confirmed,setConfirmed]=useState(false);
  const today=new Date();
  const dates=Array.from({length:14},(_,i)=>{const d=new Date(today);d.setDate(today.getDate()+i);return{day:D.days[d.getDay()],date:d.getDate()};});
  const slots=D.slots; const taken=D.takenSlots;
  const otherServices=(b.services||[]).filter(s=>s.id!==svc.id);
  const toggleAddOn=(s)=>setAddOns(prev=>prev.find(a=>a.id===s.id)?prev.filter(a=>a.id!==s.id):[...prev,s]);
  const totalAdvance=svc.advanceP+addOns.reduce((a,s)=>a+s.advanceP,0);
  const totalPrice=svc.priceP+addOns.reduce((a,s)=>a+s.priceP,0);

  if(confirmed) return (
    <div className="scale-in" style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:32,background:C.bg,textAlign:'center'}}>
      <div style={{width:100,height:100,borderRadius:50,background:'#dcfce7',display:'flex',alignItems:'center',justifyContent:'center',fontSize:50,marginBottom:24}}>✅</div>
      <h2 style={{fontSize:22,fontWeight:800,color:C.text,marginBottom:8}}>Booking confirmed!</h2>
      <p style={{fontSize:13,color:C.textMed,marginBottom:20}}>Booking ID: <b style={{color:C.text}}>BKG-{Math.floor(1000+Math.random()*9000)}</b></p>
      <Card style={{width:'100%',marginBottom:20,padding:'14px 16px',textAlign:'left'}}>
        {[[`${svc.name}${addOns.length?' + '+addOns.length+' more':''}`, 'Services'],[b.name,'Salon'],[`${dates[selDay].day}, ${dates[selDay].date} May`,'Date'],[selSlot||'3:30 PM','Slot']].map(([v,l],i)=>(
          <div key={i} style={{display:'flex',justifyContent:'space-between',marginBottom:i<3?8:0}}><span style={{fontSize:13,color:C.textMed}}>{l}</span><span style={{fontSize:13,fontWeight:700,color:C.text}}>{v}</span></div>
        ))}
        {totalAdvance>0&&<><Divider my={8}/><div style={{display:'flex',justifyContent:'space-between'}}><span style={{fontSize:12,color:C.textMed}}>Advance paid</span><span style={{fontSize:13,fontWeight:800,color:C.success}}>{fmt(totalAdvance)}</span></div></>}
      </Card>
      <Btn full onClick={()=>navigate('booking-detail',{booking:D.bookings[0]})}>View booking detail</Btn>
      <button onClick={goBack} style={{marginTop:12,background:'none',border:'none',color:C.primary,fontSize:14,fontWeight:600,cursor:'pointer'}}>Done</button>
    </div>
  );

  const steps=['Date & Slot','Review','Pay'];
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column'}}>
      <BkHdr title="Book a slot" onBack={goBack}/>
      <div style={{padding:'14px 20px 0',background:C.bg}}>
        <div style={{display:'flex',alignItems:'center',marginBottom:4}}>
          {steps.map((l,i)=>(
            <React.Fragment key={i}>
              <div style={{display:'flex',flexDirection:'column',alignItems:'center',flex:1}}>
                <div style={{width:26,height:26,borderRadius:13,background:i<=step?C.primary:'#f5f5f4',color:i<=step?C.white:C.textMed,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,transition:'background .3s'}}>{i<step?'✓':i+1}</div>
                <span style={{fontSize:9,fontWeight:600,color:i<=step?C.primary:C.textMed,marginTop:3}}>{l}</span>
              </div>
              {i<2&&<div style={{flex:2,height:2,background:i<step?C.primary:'#f5f5f4',marginBottom:18,transition:'background .3s'}}/>}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div style={{flex:1,overflowY:'auto',padding:'20px',display:'flex',flexDirection:'column',gap:16}}>
        {step===0&&<div className="slide-up" style={{display:'flex',flexDirection:'column',gap:20}}>
          <div>
            <p style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:12}}>Select a date</p>
            <div style={{display:'flex',gap:8,overflowX:'auto',paddingBottom:4,scrollbarWidth:'none'}}>
              {dates.map((d,i)=>(
                <button key={i} onClick={()=>{setSelDay(i);setSelSlot(null);}} style={{minWidth:52,padding:'10px 6px',borderRadius:14,border:`1.5px solid ${selDay===i?C.primary:C.border}`,background:selDay===i?C.primary:C.white,color:selDay===i?C.white:C.text,cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:3,flexShrink:0,transition:'all .15s'}}>
                  <span style={{fontSize:9,fontWeight:600}}>{i===0?'Today':d.day}</span>
                  <span style={{fontSize:18,fontWeight:800}}>{d.date}</span>
                </button>
              ))}
            </div>
          </div>
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',marginBottom:12}}>
              <p style={{fontSize:15,fontWeight:700,color:C.text}}>Pick a time</p>
              <p style={{fontSize:12,color:C.textMed}}>{dates[selDay].day}, {dates[selDay].date} May · {svc.duration} min</p>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
              {slots.map((t,i)=>{const tk=taken.includes(i);const sel=selSlot===t;return(
                <button key={i} disabled={tk} onClick={()=>setSelSlot(t)} style={{padding:'11px 4px',borderRadius:12,border:`1.5px solid ${sel?C.primary:C.border}`,background:sel?C.primary:tk?'#f5f5f4':C.white,color:sel?C.white:tk?C.textLight:C.text,fontSize:12,fontWeight:sel?700:500,cursor:tk?'not-allowed':'pointer',opacity:tk?.45:1,transition:'all .15s',textAlign:'center'}}>
                  {t}{tk&&<span style={{fontSize:9,display:'block',color:C.textLight,marginTop:1}}>Full</span>}
                  {!tk&&i===4&&!sel&&<span style={{fontSize:9,display:'block',color:C.warning,marginTop:1}}>1 left</span>}
                </button>
              );})}
            </div>
            {!selSlot&&<p style={{fontSize:12,color:C.textMed,marginTop:10,textAlign:'center'}}>Tap a slot to continue</p>}
          </div>
        </div>}
        {step===1&&<div className="slide-up" style={{display:'flex',flexDirection:'column',gap:14}}>
          <p style={{fontSize:16,fontWeight:700,color:C.text}}>Review your booking</p>
          <Card style={{padding:'14px 16px'}}>
            {[[svc.name,'Service'],[b.name,'Salon'],[`${dates[selDay].day}, ${dates[selDay].date} May`,'Date'],[selSlot,'Slot']].map(([v,l],i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',marginBottom:i<3?10:0}}>
                <span style={{fontSize:13,color:C.textMed}}>{l}</span><span style={{fontSize:13,fontWeight:700,color:C.text}}>{v}</span>
              </div>
            ))}
            {addOns.length>0&&<><Divider my={10}/>{addOns.map(a=>(
              <div key={a.id} style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
                <span style={{fontSize:13,color:C.text}}>+ {a.name}</span>
                <div style={{display:'flex',gap:8,alignItems:'center'}}>
                  <span style={{fontSize:12,fontWeight:700,color:C.primary}}>{fmt(a.priceP)}</span>
                  <button onClick={()=>toggleAddOn(a)} style={{width:18,height:18,borderRadius:4,border:`1px solid ${C.border}`,background:C.white,fontSize:11,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:C.textMed}}>×</button>
                </div>
              </div>
            ))}</>}
            {totalAdvance>0&&<><Divider my={10}/>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}><span style={{fontSize:13,color:C.textMed}}>Advance to pay now</span><span style={{fontSize:14,fontWeight:800,color:C.primary}}>{fmt(totalAdvance)}</span></div>
              <div style={{display:'flex',justifyContent:'space-between'}}><span style={{fontSize:12,color:C.textMed}}>Balance at salon</span><span style={{fontSize:12,fontWeight:700,color:C.text}}>{fmt(totalPrice-totalAdvance)}</span></div>
            </>}
          </Card>
          {svc.refundBy&&<div style={{padding:'12px 14px',background:C.warningBg,borderRadius:12,border:'1px solid #fde68a'}}><p style={{fontSize:12,color:'#92400e'}}>⚠️ Free until {svc.refundBy} before slot. Advance non-refundable after.</p></div>}
          <div>
            <p style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:6}}>Notes (optional)</p>
            <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Preferences, allergies, special requests…" rows={2} style={{width:'100%',padding:'11px 14px',borderRadius:12,border:`1.5px solid ${C.border}`,resize:'none',fontSize:13,color:C.text,background:C.white,outline:'none'}}/>
          </div>
          {otherServices.length>0&&(
            <div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                <p style={{fontSize:14,fontWeight:700,color:C.text}}>Also book from {b.name}</p>
                <Badge bg="#e6f7fb" color={C.primary} sm>Save a trip</Badge>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                {otherServices.map(s=>{const added=addOns.find(a=>a.id===s.id);return(
                  <div key={s.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',borderRadius:14,border:`1.5px solid ${added?C.primary:C.border}`,background:added?'#fff8f4':C.white,transition:'all .15s'}}>
                    <div style={{flex:1}}><p style={{fontSize:13,fontWeight:700,color:C.text}}>{s.name}</p><p style={{fontSize:11,color:C.textMed}}>⏱ {s.duration} min{s.advanceP>0?' · advance '+fmt(s.advanceP):''}</p></div>
                    <div style={{textAlign:'right',flexShrink:0}}>
                      <p style={{fontSize:13,fontWeight:800,color:C.primary,marginBottom:4}}>{fmt(s.priceP)}</p>
                      <button onClick={()=>toggleAddOn(s)} style={{padding:'5px 12px',borderRadius:8,border:'none',background:added?C.success:C.primary,color:C.white,fontSize:12,fontWeight:700,cursor:'pointer',transition:'background .15s'}}>{added?'✓ Added':'+ Add'}</button>
                    </div>
                  </div>
                );})}
              </div>
            </div>
          )}
        </div>}
        {step===2&&<div className="slide-up">
          {totalAdvance>0?(
            <div>
              <p style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:14}}>Pay advance</p>
              <Card style={{marginBottom:14,padding:'14px 16px'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}><span style={{fontSize:14,color:C.textMed}}>Advance for {svc.name}{addOns.length>0?' + '+addOns.length+' add-on'+(addOns.length>1?'s':''):''}</span><span style={{fontSize:15,fontWeight:800,color:C.primary}}>{fmt(totalAdvance)}</span></div>
                <p style={{fontSize:11,color:C.textMed}}>Balance {fmt(totalPrice-totalAdvance)} payable at salon</p>
              </Card>
              <p style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:10}}>Pay via UPI</p>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                {[{n:'GPay',c:'#34a853'},{n:'PhonePe',c:'#5f259f'},{n:'Paytm',c:'#00baf2'},{n:'Cred',c:'#1a1a2e'}].map(app=>(
                  <button key={app.n} onClick={()=>setConfirmed(true)} style={{padding:'14px',borderRadius:14,border:`1.5px solid ${C.border}`,background:C.white,cursor:'pointer',display:'flex',alignItems:'center',gap:10}}>
                    <div style={{width:32,height:32,borderRadius:8,background:app.c,display:'flex',alignItems:'center',justifyContent:'center',color:C.white,fontSize:10,fontWeight:800,flexShrink:0}}>{app.n.slice(0,2)}</div>
                    <span style={{fontSize:13,fontWeight:700,color:C.text}}>{app.n}</span>
                  </button>
                ))}
              </div>
            </div>
          ):(
            <div>
              <p style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:14}}>Confirm booking</p>
              <Card style={{padding:'14px 16px',marginBottom:16}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}><span style={{fontSize:14,color:C.textMed}}>Total (pay at salon)</span><span style={{fontSize:15,fontWeight:800,color:C.primary}}>{fmt(totalPrice)}</span></div>
                {addOns.length>0&&<p style={{fontSize:11,color:C.textMed}}>{svc.name} + {addOns.map(a=>a.name).join(', ')}</p>}
              </Card>
              <Btn full onClick={()=>setConfirmed(true)}>Confirm booking →</Btn>
            </div>
          )}
        </div>}
      </div>
      {step<2&&(
        <div style={{padding:'12px 20px 20px',background:C.bg,borderTop:`1px solid ${C.border}`}}>
          <Btn full disabled={step===0&&!selSlot} onClick={()=>setStep(s=>s+1)}>
            {step===0?'Review booking →':'Proceed to payment →'}
          </Btn>
        </div>
      )}
    </div>
  );
};
